import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { map, Observable } from 'rxjs';

import { DialogComponent } from '@shared/components/dialog/dialog.component';
import { DialogData } from '@shared/models/dialog.model';

export interface SessionTimeoutDialogHandle {
  dialogRef: MatDialogRef<DialogComponent, unknown>;
  reloginRequested$: Observable<boolean>;
}

const SESSION_TIMEOUT_DIALOG_DATA: DialogData = {
  title: 'Session Expiring Soon',
  contentType: 'string',
  content: 'Your session is about to expire. Re-login now to keep working without interruption.',
  disableClose: true,
  showFooter: true,
  showCloseButton: false,
  actions: [
    {
      label: 'Re-login',
      value: true,
      type: 'primary',
      handler: (_component, dialogRef): void => {
        dialogRef.close(true);
      },
    },
    {
      label: 'Not now',
      value: false,
      handler: (_component, dialogRef): void => {
        dialogRef.close(false);
      },
    },
  ],
};

export const openSessionTimeoutDialog = (dialog: MatDialog): SessionTimeoutDialogHandle => {
  const dialogRef = dialog.open(DialogComponent, {
    data: SESSION_TIMEOUT_DIALOG_DATA,
    disableClose: true,
    autoFocus: true,
    width: '420px',
  });

  return {
    dialogRef,
    reloginRequested$: dialogRef.afterClosed().pipe(map((result) => result === true)),
  };
};
